import * as AccordionPrimitive from "@radix-ui/react-accordion";
import type { ComponentProps } from "react";
import { cn } from "../lib/cn";
import { Icon } from "./icon";

/** `[data-accordion-trigger]` / `[data-accordion-panel]` on Radix Accordion (keyboard + aria-expanded built in). */
export const Accordion = AccordionPrimitive.Root;

export function AccordionItem({ className, ...rest }: ComponentProps<typeof AccordionPrimitive.Item>) {
  return <AccordionPrimitive.Item className={cn("border-b border-line last:border-b-0", className)} {...rest} />;
}

export function AccordionTrigger({ className, children, ...rest }: ComponentProps<typeof AccordionPrimitive.Trigger>) {
  return (
    <AccordionPrimitive.Header className="flex">
      <AccordionPrimitive.Trigger
        className={cn(
          "group flex w-full cursor-pointer items-center justify-between gap-3 px-5 py-3.5 text-left text-sm font-semibold text-fg hover:bg-surface-2",
          className,
        )}
        {...rest}
      >
        {children}
        <Icon
          name="chevron-down"
          className="size-4 text-fg-subtle transition-transform group-data-[state=open]:rotate-180 motion-reduce:transition-none"
        />
      </AccordionPrimitive.Trigger>
    </AccordionPrimitive.Header>
  );
}

export function AccordionContent({ className, children, ...rest }: ComponentProps<typeof AccordionPrimitive.Content>) {
  return (
    <AccordionPrimitive.Content className="text-sm text-fg-muted" {...rest}>
      <div className={cn("px-5 pb-4", className)}>{children}</div>
    </AccordionPrimitive.Content>
  );
}
